import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';

const BASE_MIRROR_STYLES = {
  position: 'absolute',
  top: 0,
  left: 0,
  visibility: 'hidden',
  height: 0,
  overflow: 'scroll',
  whiteSpace: 'pre'
};
function formatWidthProp(value, fallback) {
  if (typeof value === 'string') {
    return value;
  }
  if (value) {
    return `${value}px`;
  }
  return fallback;
}
function copyStyles(styles, node) {
  const {
    fontSize,
    fontFamily,
    fontWeight,
    fontStyle,
    letterSpacing,
    textTransform,
    minWidth,
    maxWidth
  } = styles;
  Object.assign(node.style, _objectSpread2(_objectSpread2({}, BASE_MIRROR_STYLES), {}, {
    fontSize,
    fontFamily,
    fontWeight,
    fontStyle,
    letterSpacing,
    textTransform,
    minWidth,
    maxWidth
  }));
}
function setInputWidth(el, _ref) {
  let {
    value
  } = _ref;
  const options = _objectSpread2({
    extraWidth: 16
  }, value);
  let val = el.instance.value;
  if (!val) {
    val = el.instance.placeholder || '';
  }
  el.mirror.innerText = val;
  const newWidth = el.mirror.getBoundingClientRect().width + options.extraWidth + 2;
  if (el.children.length > 2) {
    el.instance.style.width = `${newWidth}px`;
    return;
  }
  el.style.width = `${newWidth}px`;
}
function bind(el, _ref2) {
  let {
    value
  } = _ref2;
  if (!value) {
    return;
  }
  el.instance = el;
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    const input = el.querySelector('input');
    if (!input) {
      return;
    }
    el.instance = input;
  }
}
function inserted(el, _ref3) {
  let {
    value
  } = _ref3;
  if (!value) {
    return;
  }
  el.mirror = document.createElement('span');
  const styles = window.getComputedStyle(el.instance);
  const {
    fontSize,
    fontFamily,
    fontWeight,
    fontStyle,
    letterSpacing,
    textTransform
  } = styles;
  const boundStyles = {
    fontSize,
    fontFamily,
    fontWeight,
    fontStyle,
    letterSpacing,
    textTransform,
    maxWidth: formatWidthProp(value.maxWidth, '960px'),
    minWidth: formatWidthProp(value.minWidth, 0)
  };
  el.instance.style.maxWidth = boundStyles.maxWidth;
  el.instance.style.minWidth = boundStyles.minWidth;
  el.style.minWidth = boundStyles.minWidth;
  el.style.maxWidth = boundStyles.maxWidth;
  copyStyles(boundStyles, el.mirror);
  el.appendChild(el.mirror);
  setInputWidth(el, {
    value
  });
}
function componentUpdated(el, _ref4) {
  let {
    value
  } = _ref4;
  if (!value) {
    return;
  }
  setInputWidth(el, {
    value
  });
}
function unbind(el, _ref5) {
  let {
    value
  } = _ref5;
  if (!value) {
    return;
  }
  el.removeChild(el.mirror);
}
const PendoInputAutowidth = {
  bind,
  inserted,
  componentUpdated,
  unbind
};
var PendoInputAutowidth$1 = PendoInputAutowidth;

export { PendoInputAutowidth, PendoInputAutowidth$1 as default, formatWidthProp, setInputWidth };
//# sourceMappingURL=pendo-input-autowidth.js.map
